export default "__VITE_ASSET__BcMu4CUy__"